import { apiClient } from './client';
import type {
  OkdocLandingCatalogFilters,
  OkdocLandingCatalogResponse,
  OkdocLandingDefinitionRequest,
  OkdocLandingDefinitionResponse,
  OkdocLandingSendTestRequest,
  OkdocLandingSendTestResponse,
  OkdocLandingDefinitionUpdateRequest,
  OkdocLandingPreviewResponse,
} from '@/types/okdocLandings';

export const okdocLandingsApi = {
  async list(params: OkdocLandingCatalogFilters): Promise<OkdocLandingCatalogResponse> {
    const { data } = await apiClient.get('/okdoc/landings', { params });
    return data;
  },

  async preview(key: string): Promise<OkdocLandingPreviewResponse> {
    const { data } = await apiClient.get('/okdoc/landings/preview', {
      params: { key },
    });
    return data;
  },

  async getDefinition(params: OkdocLandingDefinitionRequest): Promise<OkdocLandingDefinitionResponse> {
    const { data } = await apiClient.get('/okdoc/landings/definition', { params });
    return data;
  },

  async updateDefinition(payload: OkdocLandingDefinitionUpdateRequest): Promise<OkdocLandingDefinitionResponse> {
    const { data } = await apiClient.patch('/okdoc/landings/definition', payload, {
      params: { tenant_id: payload.tenant_id },
    });
    return data;
  },

  async sendTest(payload: OkdocLandingSendTestRequest): Promise<OkdocLandingSendTestResponse> {
    const { data } = await apiClient.post('/okdoc/landings/send-test', payload);
    return data;
  },
};
